/**
 * @generated SignedSource<<1d2c3f150582abbd0be1d65d935962e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EnrollmentSortBy = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "EMAIL_ASC" | "EMAIL_DESC" | "NAME_ASC" | "NAME_DESC" | "SCORE_ASC" | "SCORE_DESC" | "WEEK_ASC" | "WEEK_DESC" | "%future added value";
export type GroupEnrollmentSortBy = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "NAME_ASC" | "NAME_DESC" | "%future added value";
export type CoachProgramEnrollmentsRouteQuery$variables = {
  after?: string | null | undefined;
  enrollmentOrderBy?: EnrollmentSortBy | null | undefined;
  first?: number | null | undefined;
  groupEnrollmentOrderBy?: GroupEnrollmentSortBy | null | undefined;
  maxEnrollments: number;
  programSlug: string;
};
export type CoachProgramEnrollmentsRouteQuery$data = {
  readonly clients: {
    readonly " $fragmentSpreads": FragmentRefs<"EnrollDialog_clients">;
  } | null | undefined;
  readonly enrollments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"ProgramEnrollments_enrollments">;
  } | null | undefined;
  readonly enrollmentsAvatars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EnrolledAvatars_connection">;
  } | null | undefined;
  readonly groupEnrollments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"ProgramEnrollments_groupEnrollments">;
  } | null | undefined;
  readonly groups: {
    readonly " $fragmentSpreads": FragmentRefs<"EnrollDialog_groups">;
  } | null | undefined;
  readonly program: {
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"EnrollDateDialog_program" | "EnrollDialog_program" | "ProgramSettings_program" | "RefreshSlug">;
  } | null | undefined;
};
export type CoachProgramEnrollmentsRouteQuery = {
  response: CoachProgramEnrollmentsRouteQuery$data;
  variables: CoachProgramEnrollmentsRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enrollmentOrderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupEnrollmentOrderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxEnrollments"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "programSlug"
},
v6 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "programSlug"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v15 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v16 = {
  "kind": "Variable",
  "name": "programSlug",
  "variableName": "programSlug"
},
v17 = [
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "enrollmentOrderBy"
  },
  (v16/*: any*/)
],
v18 = [
  (v11/*: any*/)
],
v19 = [
  (v10/*: any*/)
],
v20 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "maxEnrollments"
  },
  (v16/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM Do"
  },
  {
    "kind": "Literal",
    "name": "utc",
    "value": true
  }
],
v24 = [
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "groupEnrollmentOrderBy"
  },
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachProgramEnrollmentsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramSettings_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDateDialog_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RefreshSlug"
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_clients"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_groups"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": null,
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "__Program_enrollmentsAvatars_connection",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrolledAvatars_connection"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "enrollments",
        "args": (v17/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "__Program_enrollments_connection",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramEnrollments_enrollments"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "groupEnrollments",
        "args": null,
        "concreteType": "GroupEnrollmentConnection",
        "kind": "LinkedField",
        "name": "__Program_groupEnrollments_connection",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupEnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupEnrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramEnrollments_groupEnrollments"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachProgramEnrollmentsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v9/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "length",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InviteCode",
            "kind": "LinkedField",
            "name": "inviteCode",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slugId",
                "storageKey": null
              }
            ],
            "type": "Slug",
            "abstractKey": "__isSlug"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": (v20/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": (v20/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "Program_enrollmentsAvatars",
        "kind": "LinkedHandle",
        "name": "enrollments"
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(format:\"MMM Do\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": "endDate(format:\"MMM Do\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "period",
                        "value": "BEFORE_NOW"
                      }
                    ],
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "unlockedScore",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "completion(period:\"BEFORE_NOW\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viaGroup",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "filters": [
          "first",
          "after",
          "orderBy",
          "programSlug"
        ],
        "handle": "connection",
        "key": "Program_enrollments",
        "kind": "LinkedHandle",
        "name": "enrollments"
      },
      {
        "alias": null,
        "args": (v24/*: any*/),
        "concreteType": "GroupEnrollmentConnection",
        "kind": "LinkedField",
        "name": "groupEnrollments",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupEnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupEnrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v24/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "Program_groupEnrollments",
        "kind": "LinkedHandle",
        "name": "groupEnrollments"
      }
    ]
  },
  "params": {
    "cacheID": "e231ed7863f2851adc057779e65daac5",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "maxEnrollments",
          "cursor": null,
          "direction": "forward",
          "path": [
            "enrollmentsAvatars"
          ]
        },
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "enrollments"
          ]
        },
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "groupEnrollments"
          ]
        }
      ]
    },
    "name": "CoachProgramEnrollmentsRouteQuery",
    "operationKind": "query",
    "text": "query CoachProgramEnrollmentsRouteQuery(\n  $programSlug: String!\n  $maxEnrollments: Int!\n  $first: Int\n  $after: String\n  $enrollmentOrderBy: EnrollmentSortBy\n  $groupEnrollmentOrderBy: GroupEnrollmentSortBy\n) {\n  program(slug: $programSlug) {\n    ...ProgramSettings_program\n    ...EnrollDialog_program\n    ...EnrollDateDialog_program\n    ...RefreshSlug\n    id\n    name\n    slug\n  }\n  clients {\n    ...EnrollDialog_clients\n  }\n  groups {\n    ...EnrollDialog_groups\n  }\n  enrollmentsAvatars: enrollments(programSlug: $programSlug, first: $maxEnrollments) {\n    totalCount\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...EnrolledAvatars_connection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  enrollments(programSlug: $programSlug, first: $first, after: $after, orderBy: $enrollmentOrderBy) {\n    totalCount\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    ...ProgramEnrollments_enrollments\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  groupEnrollments(programSlug: $programSlug, first: $first, after: $after, orderBy: $groupEnrollmentOrderBy) {\n    totalCount\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    ...ProgramEnrollments_groupEnrollments\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Avatar_user on User {\n  displayName\n  photoURL\n}\n\nfragment EnrollDateDialog_program on Program {\n  id\n}\n\nfragment EnrollDialog_clients on ClientConnection {\n  totalCount\n}\n\nfragment EnrollDialog_groups on GroupConnection {\n  totalCount\n}\n\nfragment EnrollDialog_program on Program {\n  id\n  name\n}\n\nfragment EnrolledAvatar_enrollment on Enrollment {\n  client {\n    ...Avatar_user\n    id\n  }\n}\n\nfragment EnrolledAvatars_connection on EnrollmentConnection {\n  totalCount\n  edges {\n    node {\n      id\n      ...EnrolledAvatar_enrollment\n    }\n  }\n}\n\nfragment EnrollmentCard_enrollment on Enrollment {\n  id\n  client {\n    id\n    username\n    displayName\n    email\n    photoURL\n  }\n  startDate(utc: true, format: \"MMM Do\")\n  endDate(utc: true, format: \"MMM Do\")\n  completion(period: BEFORE_NOW) {\n    unlockedScore: rate\n  }\n  viaGroup\n}\n\nfragment EnrollmentList_enrollments on EnrollmentConnection {\n  totalCount\n  edges {\n    node {\n      id\n      ...EnrollmentCard_enrollment\n    }\n  }\n}\n\nfragment GroupEnrollmentCard_groupEnrollment on GroupEnrollment {\n  id\n  group {\n    name\n    size\n    id\n  }\n}\n\nfragment GroupEnrollmentList_groupEnrollments on GroupEnrollmentConnection {\n  totalCount\n  edges {\n    node {\n      id\n      ...GroupEnrollmentCard_groupEnrollment\n    }\n  }\n}\n\nfragment InviteLinkSettings_inviteCode on InviteCode {\n  id\n  code\n}\n\nfragment ProgramEnrollments_enrollments on EnrollmentConnection {\n  totalCount\n  ...EnrollmentList_enrollments\n}\n\nfragment ProgramEnrollments_groupEnrollments on GroupEnrollmentConnection {\n  totalCount\n  ...GroupEnrollmentList_groupEnrollments\n}\n\nfragment ProgramSettings_program on Program {\n  id\n  slug\n  name\n  description\n  imageURL\n  status\n  length\n  defaultView\n  inviteCode {\n    ...InviteLinkSettings_inviteCode\n    id\n    startDate\n  }\n}\n\nfragment RefreshSlug on Slug {\n  __isSlug: __typename\n  slug\n  slugId\n}\n"
  }
};
})();

(node as any).hash = "9f3fd2ecc627c90835f49b52d88d3b79";

export default node;
